import _get from 'lodash/get';

export const getDefaultSlug = items => {
  const sortedAndFilteredItems = items
    .filter(({ showMenu }) => showMenu === 'yes' || !showMenu)
    .sort((a, b) => a.menuOrder - b.menuOrder);
  return sortedAndFilteredItems[0].slug;
};
export const getClientUrl = clientDetails => _get(clientDetails, 'url');

export const shouldPathShowSubscription = pathname =>
  pathname.startsWith('/topics') ||
  pathname.startsWith('/assessments') ||
  pathname.startsWith('/blogs') ||
  pathname.startsWith('/apps') ||
  pathname.startsWith('/books') ||
  pathname.startsWith('/podcasts') ||
  pathname.startsWith('/videos') ||
  pathname.startsWith('/articles') ||
  pathname.startsWith('/people') ||
  pathname.startsWith('/organizations') ||
  pathname.startsWith('/insights');

export const getClientLogo = clientDetails =>
  _get(clientDetails, ['logoReverse', 'url']);

export const getCMClientLogo = clientDetails =>
  _get(clientDetails, ['crediblemindLogo', 'url']);
